// src/services/socialAuthApi.js
// Centralized API utility for social login

export async function socialAuthApi({ provider, credential, code, email, name, role }) {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/social`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'accept': '*/*' },
    body: JSON.stringify({ provider, credential, code, email, name, role })
  });
  if (!res.ok) throw new Error('Social login failed');
  return res.json(); // { user, accessToken, refreshToken }
}
